import React, { useState } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";
import Icon from "@material-ui/core/Icon";
import { setOpenSource } from "../actions/sources";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(3),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));
const AddSourceBtn = ({ dispatch }) => {
  const classes = useStyles();

  return (
    <div className="fixed-action-btn">
      <Fab
        onClick={() => dispatch(setOpenSource(true))}
        color="primary"
        aria-label="Add"
        className={classes.fab}
      >
        <Icon>add</Icon>
      </Fab>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    sources: state.sources.sources,
    current: state.sources.current,
  };
};

export default connect(mapStateToProps)(AddSourceBtn);
